import apiClient from '../middleware/apiClient';
import { OT_HOP_INITIALIZATION } from '../helpers/apis';
import { flagEnabled } from '../helpers/featureFlags';
import { COTTON_OT_HOP_INITIALIZATION } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_OT_HOP_INITIALIZATION = 'GET_OT_HOP_INITIALIZATION';
export const GET_OT_HOP_INITIALIZATION_SUCCESS = 'GET_OT_HOP_INITIALIZATION_SUCCESS';
export const GET_OT_HOP_INITIALIZATION_FAILURE = 'GET_OT_HOP_INITIALIZATION_FAILURE';


function dispatchGetOtHOPInitialization(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_OT_HOP_INITIALIZATION : OT_HOP_INITIALIZATION;
  return {
    type: GET_OT_HOP_INITIALIZATION,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetOtHOPInitializationSuccess(paymentDetails) {
  return {
    type: GET_OT_HOP_INITIALIZATION_SUCCESS,
    payload: paymentDetails,
  };
}

function dispatchGetOtHOPInitializationError(error) {
  return {
    type: GET_OT_HOP_INITIALIZATION_FAILURE,
    payload: error,
  };
}

export const getOtHOPInitialization = () => async (dispatch) => {
  const isCottonSession = getCottonSession();
  if (flagEnabled('xmTxnDataEnabled')) {
    try {
      const response = await dispatch(dispatchGetOtHOPInitialization(isCottonSession)).payload;
      return dispatch(dispatchGetOtHOPInitializationSuccess(response));
    } catch (error) {
      dispatch(dispatchGetOtHOPInitializationError(error));
      throw error;
    }
  }
  return null;
};
